import {ImgMasked as ImgMaskedModel} from '../../models/editor/imgMasked'
import StyleSheet from '../../utils/helpers/styleSheet'
import Img from './Img'

interface ImgMaskedProps {
  img: ImgMaskedModel
}

export default function ImgMasked({img}: ImgMaskedProps) {
  const insideImageStyle = (index: number): StyleSheet => {
    if (index >= 0 && index < img.inside.length) {
      const insideImage = img.inside[index]
      if (insideImage) {
        return {
          style: {
            transformOrigin: 'center',
            transform: `translate(${insideImage.position.x}%, ${insideImage.position.y}%) scale(${insideImage.scale})`,
          },
        }
      }
    }
    return {style: {}}
  }

  const width = Math.ceil(500 * (img.width / Math.max(img.width, img.height)))
  const height = Math.ceil(500 * (img.height / Math.max(img.width, img.height)))

  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        className="maskedSvg">
        <defs>
          {img.inside.map((insideImage, index) =>
            insideImage ? (
              <mask
                key={`mask_${img.id}_${index}`}
                id={`mask_${img.id}_${index}`}
                maskUnits="userSpaceOnUse"
                maskContentUnits="userSpaceOnUse">
                <image
                  href={insideImage.maskUrl}
                  width={width}
                  height={height}
                  preserveAspectRatio="xMidYMid meet"
                  style={{filter: `invert(${insideImage.black ? 1 : 0})`}}
                />
              </mask>
            ) : null,
          )}
        </defs>
        <image href={img.url} width={width} height={height} />
        {img.inside.map((insideImage, index) =>
          insideImage ? (
            <g
              key={`insideImage_${img.id}_${index}`}
              mask={`url(#mask_${img.id}_${index})`}>
              <image
                href={insideImage.url}
                width={width}
                height={height}
                preserveAspectRatio="xMidYMid meet"
                style={insideImageStyle(index).style}
              />
            </g>
          ) : null,
        )}
      </svg>

      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: `translate(-50%, -50%) scale(${img.captionsScale})`,
        }}>
        {img.captions.map(caption => (
          <Img
            img={caption}
            key={`maskedImageCaption_${img.id}_${caption.id}`}
            noZoom
          />
        ))}
      </div>
    </>
  )
}
